import { useState, useContext } from "react";
import { AuthContext, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Package } from "lucide-react";

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
      });
      login(response.data.access_token, response.data.user);
      toast.success("Erfolgreich angemeldet!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl border border-slate-200 animate-fade-in">
        <div className="flex flex-col items-center mb-8">
          <img 
            src="/apple-touch-icon-180-square.png" 
            alt="MPS Logo" 
            className="w-20 h-20 mb-4 rounded-2xl shadow-lg"
          />
          <h1 className="text-3xl font-bold text-slate-900">Artikelverwaltung</h1>
          <p className="text-slate-600 mt-2">Melden Sie sich an, um fortzufahren</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label htmlFor="email" className="text-slate-700 font-medium">
              E-Mail
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              className="mt-2 h-11 border-slate-300 focus:border-blue-500"
              placeholder="ihre.email@beispiel.de"
            />
          </div>

          <div>
            <Label htmlFor="password" className="text-slate-700 font-medium">
              Passwort
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              className="mt-2 h-11 border-slate-300 focus:border-blue-500"
              placeholder="••••••••"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-md"
          >
            {loading ? "Wird angemeldet..." : "Anmelden"}
          </Button>
        </form>
      </div>
    </div>
  );
}
